<template>
  <section class="s-title">
    <div class="left" >
        <p><span>{{mainTitle}}</span>&nbsp;&nbsp;<span class="thin" v-if="$store.getters.roler==='admin'">{{subTitle}}</span></p>
        <p class="bottom">{{description}}</p>
    </div>
  </section>
</template>
<script>
export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author stone
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'component_name',
  components: {},
  props: {
    mainTitle: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    marginbottom: {
      type: String,
      default: '20'
    }
  },
  data () {
    return {
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="less" scoped>
 .left:first-child {
      text-align: left;
      font-size:0.16rem;
      // font-size:32px;
      // margin-bottom:20px;
      margin-bottom:0.01rem;

      font-family:PingFangSC-Medium;
    }
    .thin{
      font-family:PingFangSC-Thin;
    }
   .bottom {
      // font-size:16px;
      font-size:0.08rem;
      color:#363636 ;
      font-family:PingFangSC-Thin;
      // margin-top:20px;
      margin-top:0.08rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/STitleHeader.vue